import { AbstractDataProviderV2 } from 'components/system';
import { CustomerCardAssign, RsCustomerCardBatch, RsCustomerCardBatchInfo } from 'common/customers/services';

export class CustomerCardsBatchDataProvider extends AbstractDataProviderV2<RsCustomerCardBatch> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/cards/batch');
    }

    public patch(): Promise<null> {
        return Promise.reject('Method is not supported');
    }

    public update(): Promise<null> {
        return Promise.reject('Method is not supported');
    }

    public add(): Promise<null> {
        return Promise.reject('Method is not supported');
    }

    public assign(data: CustomerCardAssign): Promise<RsCustomerCardBatchInfo> {
        return this.service.updateRequest<RsCustomerCardBatchInfo>(this.apiUrl + '/assign', 'POST', data);
    }
}
